import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  customerList: [],
  totalItems: 0,
  itemsPerPage: 0,
  customerDetail: null,
};

const slice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getCustomerListSuccess(state, action) {
      state.isLoading = false;
      state.customerList = action.payload.data;
      state.totalItems = action.payload.pagination?.totalItems || 0;
      state.itemsPerPage = action.payload.pagination?.itemsPerPage || 0;
    },

    getCustomerDetailSuccess(state, action) {
      state.isLoading = false;
      state.customerDetail = action.payload.data;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getCustomerPagination(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/admin/customers-with-order-stats', {
        params: { ...data },
      });
      dispatch(slice.actions.getCustomerListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCustomerDetail(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/admin/customers/${id}`);
      dispatch(slice.actions.getCustomerDetailSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
